// extracted by mini-css-extract-plugin
export default {"row":"PersonForm_row__UYQBJ","inputMasked":"PersonForm_inputMasked__YLLZv","placeHolderShimmer":"PersonForm_placeHolderShimmer__GzG9S"};